'use strict';

var focusHelper = require('@sfra/components/focus');
var $body = $('body');
var $trackingConsent = $('.tracking-consent');
var $languageSelectModal = $('#language-select-modal');

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function showConsentModal() {
    if (!$trackingConsent.data('caonline') || $languageSelectModal.length === 0) {
        return;
    }

    $.spinner().start();

    $languageSelectModal.modal('show');

    $languageSelectModal.find('.button-wrapper button').click(function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function () {
                $languageSelectModal.modal('hide');
                $.spinner().stop();
            },
            error: function () {
                $languageSelectModal.modal('hide');
                $.spinner().stop();
            }
        });
    });
}

module.exports = function () {
    if ($('.consented').length === 0 && $trackingConsent.hasClass('api-true')) {
        showConsentModal();
    }

    if ($trackingConsent.hasClass('api-true')) {
        $trackingConsent.click(function () {
            showConsentModal();
        });
    }

    $body.on('shown.bs.modal', '#language-select-modal', function () {
        $languageSelectModal.siblings().attr('aria-hidden', 'true');
        $languageSelectModal.find('.close').focus();
    });

    $body.on('hidden.bs.modal', '#language-select-modal', function () {
        $languageSelectModal.siblings().attr('aria-hidden', 'false');
        $languageSelectModal.remove();
        $.spinner().stop();
    });

    $body.on('keydown', '#language-select-modal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#language-select-modal',
            firstElementSelector: '.affirm',
            lastElementSelector: '.decline',
            nextToLastElementSelector: '.affirm'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $body.on('initAccessibilityOneTrust', function () {
        var $oneTrustContainer = $('#onetrust-consent-sdk');

        if ($oneTrustContainer.length) {
            var srTextPreferences = '<span class="sr-only">One Trust Cookie Preferences</span>';
            var srTextClose = '<span class="sr-only">Close One Trust Cookie Preferences</span>';
            var $frontButton = $oneTrustContainer.find('button.ot-floating-button__open');
            var $backButton = $oneTrustContainer.find('button.ot-floating-button__close');

            if ($frontButton.length) {
                if ($frontButton.children('span.sr-only').length) {
                    return;
                } else {
                    $frontButton.prepend(srTextPreferences);
                }
            }

            if ($backButton.length) {
                $backButton.find('[id="Line"]').removeAttr('id');
                if ($backButton.children('span.sr-only').length) {
                    return;
                } else {
                    $backButton.prepend(srTextClose);
                }
            }
        }
    });
};
